<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <select
              class="form-control"
              v-model="searchMonth"
              @change="changeSearchMonth"
            >
              <option value disabled>請選擇查詢月份</option>
              <option
                v-for="month in searchMonthList"
                :value="month.value"
                :key="month.value"
              >
                {{ month.label }}
              </option>
            </select>
            <div class="pt-3">
              <div class="card mb-3" v-for="record in records" :key="record.id">
                <div class="card-header bg-primary text-white">
                  訂單編號 {{ record.CODE }}
                </div>
                <div class="card-body">
                  <p>
                    購買類別：
                    <span v-if="record.SALESTYPE == 0">首購</span>
                    <span v-if="record.SALESTYPE == 1">定期</span>
                    <span v-if="record.SALESTYPE == 2">加購</span>
                  </p>
                  <p>營業月份： {{ formatMonth(record.RESULTMONTH) }}</p>
                  <p>
                    <span
                      v-html="
                        `金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;額`
                      "
                    ></span
                    >： NT$ {{ getNumberWithCommas(record.VALUE) }} 元
                  </p>
                  <!-- <button
                    :to="`/member/record-list/${record.id}`"
                    class="btn btn-primary btn-block"
                  >檢視訂單詳情</button> -->
                  <b-button @click="clickRecord(record)" v-b-modal.recordModal
                    >檢視訂單詳情</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="recordModal"
        :title="`訂單編號 ${activeRecord.CODE}`"
        hide-footer
      >
        <template>
          <div>
            <p>
              訂購日期： {{ activeRecord.RECEIPTDATE | moment("YYYY/MM/DD") }}
            </p>
            <p>會員資格： {{ detail.courseName }}</p>
            <p>購買類別： {{ saleType }}</p>
            <p>營業月份： {{ formatMonth(activeRecord.RESULTMONTH) }}</p>
            <p>
              <span
                v-html="`金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;額`"
              ></span
              >： NT$ {{ getNumberWithCommas(activeRecord.VALUE) }} 元
            </p>
            <p>
              <span v-html="`收&nbsp;&nbsp;件&nbsp;&nbsp;人`"></span>：
              {{ activeRecord.NAME }}
            </p>
            <p>送貨地點：</p>
            <p>{{ activeRecord.ADDRESS1 }}{{ activeRecord.ADDRESS2 }}</p>
            <ul class="list-group">
              <li
                v-for="item in detail.items"
                :key="item.CODE.toString()"
                class="list-group-item"
              >
                <p class="font-weight-bold">
                  {{ detail.itemsMap[item.IPACKAGE].NAME }}
                </p>
                <p>數量： {{ item.NET }}</p>
                <p>金額： NT$ {{ getNumberWithCommas(item.PRICE) }} 元</p>
              </li>
            </ul>
          </div>
        </template>
      </b-modal>
    </MemberLayout>
  </div>
</template>
<script>
import {
  getBusinessMonthList,
  getNumberWithCommas,
} from "../../api/fordaysHelpers";
import { mapGetters } from "vuex";
import db from "../../api/db";
import MemberLayout from "../../components/member/MemberLayout";
export default {
  name: "RecordListScreen",
  components: {
    MemberLayout,
  },
  computed: {
    ...mapGetters(["getAuth"]),
    saleType() {
      const vm = this;
      if (vm.activeRecord.SALESTYPE == 0) {
        return "首購";
      } else if (vm.activeRecord.SALESTYPE == 1) {
        return "定期";
      } else {
        return "加購";
      }
    },
  },
  data() {
    return {
      searchMonthList: getBusinessMonthList(),
      searchMonth: "",
      user: {},
      records: [],
      activeRecord: {},
      detail: {
        items: [],
        courseName: "",
        itemsMap: {},
      },
    };
  },
  methods: {
    changeSearchMonth() {
      const vm = this;
      const searchMonth = vm.searchMonth;
      const user = vm.user;
      db.collection(`jsellout/${searchMonth}/monthData`)
        .where("SEQ", "==", user.SEQ)
        .get()
        .then((sellDocs) => {
          const records = [];
          sellDocs.forEach((doc) => {
            const record = doc.data();
            record.id = doc.id;
            records.push(record);
          });
          vm.records = records;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNumberWithCommas(val) {
      return getNumberWithCommas(val);
    },
    clickRecord(record) {
      const vm = this;
      vm.activeRecord = {};
      vm.detail = {
        items: [],
        courseName: "",
        itemsMap: {},
      };
      vm.activeRecord = record;
      async function fetchData() {
        const itemDocs = await db
          .collection(`jsellitemout/${record.RESULTMONTH}/monthData`)
          .where("SELLCODE", "==", record.CODE)
          .get();
        const items = [];
        itemDocs.forEach((doc) => {
          const item = doc.data();
          items.push(item);
        });
        const itemsMapList = await Promise.all(
          items.map((item) => {
            return db
              .doc(`jitemout/${item.IPACKAGE}`)
              .get()
              .then((doc) => {
                return doc.data();
              });
          })
        );
        const itemsMap = {};
        itemsMapList.forEach((item) => {
          itemsMap[item.CODE] = item;
        });

        const courseDoc = await db
          .doc(`jqualificationtypeout/${record.COURSE}`)
          .get();
        const courseName = courseDoc.data().NAME;
        const detail = {
          items: items,
          courseName: courseName,
          itemsMap: itemsMap,
        };
        vm.detail = detail;
      }
      fetchData();
    },
    formatMonth(str) {
      if (!str) {
        return "";
      }
      return str.substring(0, 4) + "/" + str.substring(4);
    },
  },
  mounted() {
    const vm = this;
    vm.user = vm.getAuth.user;
  },
};
</script>